const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY

declare global {
    interface Window {
        grecaptcha?: {
            ready: (cb: () => void) => void
            execute: (
                siteKey: string,
                options: { action: string },
            ) => Promise<string>
        }
    }
}

let scriptLoadingPromise: Promise<void> | null = null

function loadRecaptchaScript(): Promise<void> {
    if (window.grecaptcha) {
        return Promise.resolve()
    }

    if (!scriptLoadingPromise) {
        scriptLoadingPromise = new Promise<void>((resolve, reject) => {
            const script = document.createElement('script')
            script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`
            script.async = true
            script.defer = true
            script.onload = () => resolve()
            script.onerror = () => {
                scriptLoadingPromise = null
                reject(new Error('Failed to load reCAPTCHA script'))
            }
            document.head.appendChild(script)
        })
    }

    return scriptLoadingPromise!
}

export async function preloadRecaptcha(): Promise<void> {
    if (!SITE_KEY) {
        return
    }

    try {
        await loadRecaptchaScript()
    } catch (error) {
        console.error('Failed to preload reCAPTCHA', error)
    }
}

export async function executeRecaptcha(
    action: string,
): Promise<string | undefined> {
    if (!SITE_KEY) {
        return undefined
    }

    await loadRecaptchaScript()

    if (!window.grecaptcha) {
        throw new Error('reCAPTCHA is not available')
    }

    return new Promise((resolve, reject) => {
        window.grecaptcha!.ready(() => {
            window
                .grecaptcha!.execute(SITE_KEY, { action })
                .then(resolve)
                .catch(reject)
        })
    })
}
